<template>
    <card-seplag :titulo="'Dependentes'" class="" cor="#00acc1">
        <div class="p-col-12 avisos">
            <p>É obrigatório editar os dados para finalizar esta etapa.</p>
        </div>
        <card-seplag :titulo="'Dependentes cadastrados'" class="ajusteSecao" cor="#00acc1">
            <div class="p-col-12 ajusteSecao">
            <div v-if="dependentes && dependentes.length > 0" class="p-col-12 ajustePanel">
                <button  v-for="(dependenteCadastrado, index) in dependentes" :key="dependenteCadastrado.idenDependenteCiclo" type="button" @click="funcaoAccord(index)" class="p-col-12 ajustePanel">
                <Panel :toggleable="true" :collapsed="controlePanel[index]" class="p-col-12 ajustePanel">
                    <template slot="header">
                    <span class="acordion">{{colapseTeste}}</span>
                    <span>{{index + 1 + ' - ' + dependenteCadastrado.nomeDependente}}
                        <span v-if="dependenteCadastrado.situacaoDadosDependente.toLocaleUpperCase() !='PENDENTE'">
                            <span v-if="dependenteCadastrado.statDependenteCiclo=='REJEITADO'" class="statusIrregular alinhamentoNome">Rejeitado</span>
                            <span v-if="dependenteCadastrado.statDependenteCiclo=='PENDENTE_VALIDACAO'" class="statusVPendenteValidacao alinhamentoNome">AGUARDANDO VALIDAÇÃO</span>
                            <span v-if="dependenteCadastrado.statDependenteCiclo=='CONCLUIDO'" class="statusConcluido alinhamentoNome">Concluído</span>
                            <span v-if="dependenteCadastrado.statDependenteCiclo=='VALIDADO'" class="statusConcluido alinhamentoNome">Validado</span>
                        </span>
                         <span v-else class="statusPendente alinhamentoNome">Pendente</span>

                    </span>
                    <span class="acordion">{{isCollapsed}}</span>
                </template>
                 <Message
                    class="p-col-12 "
                    :closable="false"
                    severity="error"
                >
                    Todos os campos devem ser preenchidos.
                    <ul>
                        <li v-for="(itemPendente) in dependenteCadastrado.dadosPendentes" :key="itemPendente" class="dadosPendentes">{{itemPendente}}</li>
                    </ul>
                </Message>
                    <div class="p-grid p-fluid">
                        <div class="p-col-12 p-md-3 ajusteContent" v-if="dependenteCadastrado.tipoParentalidade">
                            <label><strong>Parentesco:
                                </strong>{{ dependenteCadastrado.tipoParentalidade.descTipoParentalidade }}</label>
                        </div>
                        <div class="p-col-12 p-md-2 ajusteContent" v-if="dependenteCadastrado.dataNascimento">
                            <label><strong>Data de nascimento: </strong>{{ dependenteCadastrado.dataNascimento }}</label>
                        </div>
                        <div class="p-col-12 p-md-5 ajusteContent" v-if="dependenteCadastrado.flagSexo">
                            <label><strong>Sexo: </strong>{{ dependenteCadastrado.flagSexo == 'F' ? "FEMININO" :
                                    "MASCULINO"
                            }}</label>
                        </div>
                        <!-- <hr class="p-col-12 hrDependete"> -->
                        <div class="p-col-12 p-md-3 ajusteContent">
                            <label><strong>CPF: </strong>{{ dependenteCadastrado.numrCpf ?
                                    dependenteCadastrado.numrCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4")
                                    : "Não Informado"
                            }}</label>
                        </div>
                        <div class="p-col-12 p-md-2 ajusteContent" v-if="dependenteCadastrado.descRg">
                            <label><strong>RG: </strong>{{ dependenteCadastrado.descRg ? dependenteCadastrado.descRg :
                                    "Não Informado"
                            }}</label>
                        </div>
                        <div class="p-col-12 p-md-2 ajusteContent" v-if="dependenteCadastrado.orgaoDocumento">
                            <label><strong>Órgão expedidor:
                                </strong>{{ dependenteCadastrado.orgaoDocumento.descOrgaoDocumento }}</label>
                        </div>
                        <div class="p-col-12 p-md-1 ajusteContent" v-if="dependenteCadastrado.ufRg">
                            <label><strong>UF: </strong>{{ dependenteCadastrado.ufRg.siglUf }}</label>
                        </div>
                        <div class="p-col-12 p-md-2 ajusteContent" v-if="dependenteCadastrado.dataExpedicaoRg">
                            <label><strong>Data de expedição: </strong>{{ dependenteCadastrado.dataExpedicaoRg }}</label>
                        </div>
                        <!-- <hr class="p-col-12 hrDependete"> -->
                        <div class="p-col-12 p-md-3 ajusteContent" v-if="dependenteCadastrado.nomeMae">
                            <label><strong>Nome da mãe: </strong>{{ dependenteCadastrado.nomeMae }}</label>
                        </div>
                        <div class="p-col-12 p-md-9 ajusteContent " v-if="dependenteCadastrado.numrCpfMae">
                            <label><strong>CPF da mãe:
                                </strong>{{ dependenteCadastrado.numrCpfMae.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4") }}</label>
                        </div>
                        <!-- <hr class="p-col-12 hrDependete"> -->
                        <div class="p-col-12 ajusteContent">
                            <label ><strong > {{ dependencias(dependenteCadastrado) }} </strong></label>
                        </div>
                        <!-- <hr class="p-col-12 hrDependete"> -->
                        <div class="p-col-12 ajusteContent">
                            <label><strong> Deficiências: </strong> {{ deficiencias(dependenteCadastrado) }}</label>
                        </div>
                    </div>
                </Panel>
                </button>
            </div>
            <span v-else><i>Nenhum registro encontrado</i></span>
            
            </div>
        </card-seplag>
        <div class="p-col-12">
            <div class="p-grid">
                <div class="p-col-12 p-md-2 p-md-offset-3">
                    <Button label="Voltar" @click="prevPage()" icon="pi pi-angle-left" />
                </div>
                <div class="p-col-12 p-md-2">
                    <Button label="Próximo" @click="nextPage()" icon="pi pi-angle-right" iconPos="right"
                        :disabled="!etapaVinculo || etapaVinculo && etapaVinculo.statCicloPessoaFase == 'DESABILITADO'" />
                </div>
            </div>
        </div>
        
    </card-seplag>
</template>
<script>
import CardSeplag from '@/template/CardSeplag.vue'
// import TableSeplag from '@/template/TableSeplag.vue'
// import FormSeplag from '@/template/FormSeplag.vue'
import { simNao, sexo, baseApiUrl } from '@/config/global'

const getDadosDependente = () => {
    return {
        nomeDependente: null,
        numrCpf: "",
        dataNascimento: "",
        flagSexo: null,
        descRg: null,
        dataExpedicaoRg: "",
        orgaoDocumento: null,
        ufRg: null,
        nomeMae: null,
        numrCpfMae: null,
        tipoParentalidade: null,
        tiposDeficiencias: [],
        tiposDependencias: [],
        flagTpDependencia: { name: 'Não', code: "N" },
        flagTpDeficiencia: { name: 'Não', code: "N" }
    }
}

export default {
    name: "dependentes",
    components: { CardSeplag },
    data: function () {
        return {
            faseAtual: 'DEPENDENTES',
            dadosDependente: getDadosDependente(),
            parentescos: [],
            tipoDependentes: [],
            dependentesTeste: {
                descTipoDependencia: "Não",
                statTipoDependencia: "ATIVO"
            },
            dependendenteIR: [
                { name: "SIM", code: "S" },
                { name: "NÃO", code: "N" }
            ],
            irSelecionado: null,
            tipodeficiencias: [],
            optSexo: sexo,
            dependentes: [],
            ufAll: [],
            orgaoDocumentos: [],
            controleAccord: [],
            flagEditar: false,
            flagAccordion: false,
            exibirNovoDependente: false,
            exibirDialogoDeletar: false,
            simNao: simNao,
            exibirCampoDeficiencia: false,
            exibirCampoDependencia: false,
            etapaVinculo: null,
            controlePanel:[],
            isCollapsed:false,
            colapseTeste:[],
            isSalvo: false
        }
    },
    methods: {
        async carregarDados() {
            if (this.$store.getters.getDadosPessoa) {
                 this.$http.get(`${baseApiUrl}/dependentesciclos/ciclopessoa/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`).then(res2 => {
                    this.dependentes = res2.data
                    for (let i = 0; i < this.dependentes.length; i++) {
                        this.controlePanel[i] = true
                        this.colapseTeste[i] = false
                    }
                })

                this.etapaVinculo = this.$store.getters.getEtapasCiclo[this.$store.getters.getEtapasCiclo.length-1]
                if(this.etapaVinculo.statCicloPessoaFase=='PENDENTE'){
                    this.isSalvo = true
                }

            }
        },
        dependencias(dados) {
            
            if (dados.flagTpDependencia == "S") {
                 return "DEPENDENTE DE IMPOSTO DE RENDA"
            }else {
                return "NÃO É DEPENDENTE DE IMPOSTO DE RENDA"
            }
            
        },
        deficiencias(dados) {
            if (dados.flagTpDeficiencia == "S") {             
                 return "POSSUI DEFICIÊNCIA"
            }else {
                return "NÃO POSSUI DEFICIÊNCIA"
            }
        },
        nextPage() {
            if (this.isSalvo) {
                if(this.$store.getters.getDadosPessoa && this.$store.getters.getCicloPessoa.length > 0 ){
                    let fases  = this.$store.getters.getEtapasCiclo.filter(element =>{
                        return element.fase.statFase=='ATIVO'
                    })
                    if(fases.length>0){
                        let proximaFase = ''
                        for(let i=0; i<fases.length;i++){
                            if(fases[i].fase.descFase == this.faseAtual){
                                if(fases.length > i+1){
                                    proximaFase = fases[i+1].fase.descFase
                                }else{                                    
                                    proximaFase = fases[i].fase.descFase
                                }
                                break;
                            }
                        }
                        let nomeRota = ''
                        if(proximaFase=='DADOS_PESSOAIS'){
                        nomeRota = 'RECAD_DADOS_PESSOAIS_VIEW'
                        }else if(proximaFase=='DOCUMENTO'){
                            nomeRota = 'RECAD_DOCUMENTOS_PESSOAIS_VIEW'
                        }else if(proximaFase=='ENDERECO'){
                            nomeRota = 'RECAD_ENDERECO_VIEW'
                        }else if(proximaFase=='FORMACAO_ACADEMICA'){
                            nomeRota = 'RECAD_FORMACAO_ACADEMICA_VIEW'
                        }else if(proximaFase=='CAPACITACAO'){
                            nomeRota = 'RECAD_CAPACITACAO_VIEW'
                        }else if(proximaFase=='EXPERIENCIA_PROFISSIONAL'){
                            nomeRota = 'RECAD_EXPERIENCIA_PROFISSIONAL_VIEW'
                        }else if(proximaFase=='DEPENDENTES'){
                            nomeRota = 'RECAD_DEPENDENTES_VIEW'
                        }else if(proximaFase=='QUESTIONARIO'){
                            nomeRota = 'RECAD_QUESTIONARIO_VIEW'
                        }else if(proximaFase=='VINCULOS'){
                            nomeRota = 'RECAD_VINCULOS_VIEW'
                        }
                        this.$router.push({name:nomeRota})
                    }
                }else{
                    this.$router.push({name:"recadastramento"})
                }
            } else {
                this.$emit('openDisplayModalNaoSalvou', '')
            }
        },
        prevPage() {
            if(this.$store.getters.getDadosPessoa && this.$store.getters.getCicloPessoa.length > 0 ){
                let fases  = this.$store.getters.getEtapasCiclo.filter(element =>{
                    return element.fase.statFase=='ATIVO'
                })
                if(fases.length>0){
                    let faseAnterior = ''
                    for(let i=0; i<fases.length;i++){
                        if(fases[i].fase.descFase == this.faseAtual){
                            break;
                        }else{
                            faseAnterior = fases[i].fase.descFase;
                        }
                    }
                    let nomeRota = ''
                    if(faseAnterior=='DADOS_PESSOAIS'){
                    nomeRota = 'RECAD_DADOS_PESSOAIS_VIEW'
                    }else if(faseAnterior=='DOCUMENTO'){
                        nomeRota = 'RECAD_DOCUMENTOS_PESSOAIS_VIEW'
                    }else if(faseAnterior=='ENDERECO'){
                        nomeRota = 'RECAD_ENDERECO_VIEW'
                    }else if(faseAnterior=='FORMACAO_ACADEMICA'){
                        nomeRota = 'RECAD_FORMACAO_ACADEMICA_VIEW'
                    }else if(faseAnterior=='CAPACITACAO'){
                        nomeRota = 'RECAD_CAPACITACAO_VIEW'
                    }else if(faseAnterior=='EXPERIENCIA_PROFISSIONAL'){
                        nomeRota = 'RECAD_EXPERIENCIA_PROFISSIONAL_VIEW'
                    }else if(faseAnterior=='DEPENDENTES'){
                        nomeRota = 'RECAD_DEPENDENTES_VIEW'
                    }else if(faseAnterior=='QUESTIONARIO'){
                        nomeRota = 'RECAD_QUESTIONARIO_VIEW'
                    }else if(faseAnterior=='VINCULOS'){
                        nomeRota = 'RECAD_VINCULOS_VIEW'
                    }
                    this.$router.push({name:nomeRota})
                }
            }else{
                this.$router.push({name:"recadastramento"})
            }
        },
        funcaoAccord(index) {
            this.controlePanel[index] = this.isCollapsed
            this.isCollapsed = !this.isCollapsed 
            this.controlePanel[index] =  this.colapseTeste[index] 
            this.colapseTeste[index] = !this.colapseTeste[index]
        },
    },
    mounted() {
        this.carregarDados()
    }

}
</script>
<style>
.docConcluido {
    color: #43a047;
    margin-top: 2px;
    margin-left: 15px;
}
.docPendente {
    color: #f2bf27;
    margin-top: 2px;
    margin-left: 15px;
}
.statusVPendenteValidacao{
    color: #f2bf27;
    margin-right: 3px;
}
.statusPendente{
    color: #f27777;
    margin-right: 3px;
}

.statusIrregular{
    color: #f27777;
    margin-right: 3px;
}
.statusConcluido{
    color: #43a047;
    margin-right: 3px;
}
.avisos {
    background-color: rgb(231 232 125 / 84%);
    /* Red */
    color: #000000;
    border-radius: 12px;
    margin-bottom: 10px;
}

.p-chkbox-label {
    display: initial !important;
    padding: 4px;

}

.divButton {
    width: 13vw !important;
}

.hrDependete {
    padding: 0px;
    background-color: gray;
    color: gray;
}

.checkBox {
    justify-content: space-between;

}
.ajusteSecao{
    margin-top: 20px;
}
.ajustaBotao {
    /* justify-items: ; */
    justify-content: space-between;
    margin-top: 20px;
}
.ajustePanel{
    margin-top:-15px;
}
.ajusteContent{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start !important;
    justify-items: flex-start;
    margin-right: 1500px;
}
.acordion{
    display: none;
}


.dadosPendentes{
  text-align: start;
  list-style-type: disc;
  margin-left: 2vw;
}

@media screen and (max-width: 40em) {
    .divButton {
        width: 100% !important;
    }
}
</style>